
        require('./index.scss');
        'use strict';

require('module/common/search-input');

var $ = window.$;
var selector = require('./city-selecter.js');
var $adModel = require('model/service/advert.js');
var $mod = $('.module-header-nav');


var _module = {
    init: function init() {
        selector($mod);
        this.search();
        this.placeHolder();
    },
    search: function search() {
        $mod.find('.home-search input').keyup(function (e) {
            if (e.which == 13 && $(this).val() != "" && $(this).val() != $(this).data('placeholder')) {
                var keyWord = $(this).val();
                window.open('https://home.focus.cn/decoration/list/all.html?keyWord=' + keyWord);
            }
        });
        $mod.find('.search-icon').click(function (e) {
            if ($(this).prev().val() != "" && $(this).prev().val() != $(this).prev().data('placeholder')) {
                var keyWord = $(this).prev().val();
                window.open('https://home.focus.cn/decoration/list/all.html?keyWord=' + keyWord);
            }
        });
    },
    placeHolder: function placeHolder() {
        $mod.find('.palceinfo').each(function (index, item) {
            $(item).addClass('grey').val($(this).data('placeholder'));
        });
        $mod.find('.palceinfo').focus(function () {
            if ($(this).val() == $(this).data('placeholder')) {
                $(this).val('').removeClass('grey');
            }
        }).blur(function () {
            if (!$(this).val()) {
                $(this).addClass('grey').val($(this).data('placeholder'));
            }
        });
    }
};

_module.init();;
    


// WEBPACK FOOTER //
// ./src/module/home-index/header/header-nav/index.js